module.exports = __webpack_public_path__ + "img/avatar-default.a037d9bd.svg";